/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import * as _ from 'underscore';

class FBTypeChooser extends React.Component {

    render () {
        let constants = this.props.app.config.constants;

        const debouncedConnectService = _.debounce(ConnectMixin.connectService, 300, true);

        return (
            <div className="social-connector-wrapper fb-subtype-chooser">
                <div className="subtype-selectors">
                    <div className="type-selector-button"
                        data-serviceid={constants.POST_SVC_FACEBOOK}
                        data-subtype={constants.FB_SUBTYPE_PAGE}
                        data-direct={true}
                        onClick={debouncedConnectService.bind(this)}
                        role="button"
                        aria-label="Connect Facebook Pages">
                        <div className="type-selector-icon">
                            <IconFactory.facebook round={true} large={true}/>
                        </div>
                        <div className="type-selector-label">
                            Facebook<br/>Page
                        </div>
                    </div>
                    <div className="type-selector-button"
                        data-serviceid={constants.POST_SVC_FACEBOOK}
                        data-subtype={constants.FB_SUBTYPE_GROUP}
                        data-direct={true}
                        onClick={debouncedConnectService.bind(this)}
                        role="button"
                        aria-label="Connect Facebook Groups">
                        <div className="type-selector-icon">
                            <IconFactory.facebookgroups round={true} large={true}/>
                        </div>
                        <div className="type-selector-label">
                            Facebook<br/>Group
                        </div>
                    </div>
                </div>
                <div className="back-button">
                    <button className="btn-primary reverse-fixed" onClick={(e) => {
                            e.preventDefault();

                            if (this.props.context === 'onboarding') {
                                this.props.closeAllModals();
                            }

                            if (!this.props.router.location.pathname.match("/config/social") &&
                                !this.props.router.location.pathname.match("/content/post") &&
                                _.findWhere(this.props.socials.counts, {type: constants.POST_SVC_FACEBOOK}) !== undefined) {
                                this.props.switchView("chooseAcct", constants.POST_SVC_FACEBOOK);
                            } else {
                                this.props.switchView("chooseType");
                            }

                        }}>
                        {"< go back"}
                    </button>
                </div>
            </div>
        );
    }
};

export default FBTypeChooser;
